import { useState } from 'react';
import { Link } from 'react-router-dom';

const categories = ['全部', '固體劑型', '液體劑型', '粉末劑型', '特殊劑型'];

const dosageForms = [
  {
    category: '粉末劑型',
    name: '粉劑',
    anchor: 'powder',
    icon: 'ri-contrast-drop-line',
    desc: '粉末型態原料可依產品特性調整風味與包裝方式，可直接添加於飲品或食物中，適合每日攝取量較高的成分或需要快速補充的配方。',
    tags: ['蛋白質補充', '益生菌', '維生素綜合', '兒童營養', '運動補給'],
    img: 'https://readdy.ai/api/search-image?query=powder%20supplement%20scoop%20protein%20nutrition%20powder%20white%20powder%20in%20glass%20jar%20with%20spoon%20on%20clean%20white%20marble%20surface%2C%20health%20supplement%20product%20photography%20minimal&width=400&height=260&seq=dosage-powder-new&orientation=landscape',
  },
  {
    category: '固體劑型',
    name: '錠劑',
    anchor: 'tablet',
    icon: 'ri-medicine-bottle-line',
    desc: '壓錠成型，可製作多種形狀與顏色，適合大量生產，成本具競爭力。',
    tags: ['大量生產', '成本優勢', '多種形狀'],
    img: 'https://static.readdy.ai/image/c58d2dc5fdc4f4caa90264537c733184/af325be955b437d6330a4586e3a7646e.jpeg',
  },
  {
    category: '固體劑型',
    name: '膠囊',
    anchor: 'capsule',
    icon: 'ri-capsule-line',
    desc: '分為硬膠囊與軟膠囊，可有效遮蔽原料苦澀氣味，植物性與動物性膠囊可選，是目前保健食品市場接受度最高的劑型之一。',
    tags: ['植物性可選', '油脂適用', '遮味效果佳', '易吞服'],
    img: 'https://readdy.ai/api/search-image?query=top%20down%20flat%20lay%20photography%20of%20green%20and%20transparent%20health%20supplement%20gelatin%20capsules%20spilling%20out%20from%20an%20open%20dark%20amber%20glass%20jar%20onto%20a%20smooth%20light%20beige%20marble%20surface%2C%20morning%20sunlight%20casting%20gentle%20shadows%20from%20left%20side%2C%20fresh%20green%20eucalyptus%20branch%20on%20the%20edge%20for%20natural%20wellness%20vibe%2C%20professional%20pharmaceutical%20product%20photography%20with%20shallow%20depth%20of%20field%20on%20foreground%20capsules%2C%20clean%20modern%20luxury%20aesthetic&width=400&height=260&seq=dosage-cap-combined&orientation=landscape',
  },
  {
    category: '特殊劑型',
    name: '果凍條',
    anchor: 'jelly-stick',
    icon: 'ri-drop-line',
    desc: '果凍條以 Jelly Stick 型態增加產品趣味性與接受度，直接飲食或吸食，口感好且不需配水，深受兒童、年長者與追求便利性的消費者喜愛。',
    tags: ['順暢輕盈', '水潤晶亮', '頂上煩惱'],
    img: 'https://readdy.ai/api/search-image?query=health%20supplement%20jelly%20stick%20gel%20collagen%20beauty%20product%20individual%20packet%20stick%20pouch%20on%20light%20background%2C%20fresh%20colorful%20fruit%20flavored%20health%20jelly%20product%20photography&width=400&height=260&seq=dosage-jelly-new&orientation=landscape',
  },
  {
    category: '特殊劑型',
    name: '茶包',
    anchor: 'tea-bag',
    icon: 'ri-cup-line',
    desc: '茶包劑型將乾燥植物原料或粉末充填於透析濾袋中，保留天然植物的外觀與香氣，適合以「天然」、「草本」為品牌訴求的產品定位，具有良好的市場差異化效果。',
    tags: ['草本養生', '油切', '助眠', '排毒保健', '女性調理'],
    img: 'https://readdy.ai/api/search-image?query=warm%20overhead%20flat%20lay%20of%20loose%20leaf%20herbal%20tea%20blend%20with%20dried%20chamomile%20flowers%20goji%20berries%20and%20green%20tea%20leaves%20inside%20a%20clear%20glass%20teacup%20with%20stainless%20steel%20mesh%20infuser%2C%20scattered%20dried%20botanicals%20on%20a%20light%20oak%20wooden%20table%2C%20steam%20rising%20from%20hot%20water%2C%20golden%20hour%20backlight%20from%20window%20creating%20warm%20atmospheric%20glow%2C%20organic%20wellness%20drink%20concept%20photography%2C%20high%20end%20natural%20product%20styling%20with%20linen%20fabric%20texture%20underneath&width=400&height=260&seq=dosage-tea-new&orientation=landscape',
  },
  {
    category: '液體劑型',
    name: '液劑',
    anchor: 'liquid',
    icon: 'ri-water-percent-line',
    desc: '液態型態包含口服液、飲品、滴劑等形式，有效成分溶解於液體中，吸收速度快，特別適合需快速補充、病中或對吞嚥有困難的使用族群。',
    tags: ['膠原蛋白飲', '高齡者保健', '機能飲品', '即開即飲', '快速補給'],
    img: 'https://readdy.ai/api/search-image?query=sleek%20modern%20aluminum%20stick%20pouch%20liquid%20health%20supplement%20vitamin%20drink%20standing%20upright%20on%20a%20smooth%20light%20concrete%20surface%2C%20side%20angle%20product%20photography%20with%20a%20small%20pour%20of%20colorful%20berry%20red%20liquid%20on%20the%20surface%20next%20to%20it%2C%20bright%20clean%20daylight%20studio%20lighting%20from%20right%20side%2C%20professional%20nutraceutical%20wellness%20product%20commercial%20shot%2C%20minimalist%20contemporary%20composition%20with%20negative%20space%2C%20premium%20quality%20liquid%20supplement%20packaging&width=400&height=260&seq=dosage-liquid-new&orientation=landscape',
  },
];

export default function DosageFormsSection() {
  const [active, setActive] = useState('全部');

  const filtered = active === '全部' ? dosageForms : dosageForms.filter((d) => d.category === active);

  return (
    <section className="py-20 bg-[#f7faf7]">
      <div className="max-w-screen-xl mx-auto px-6 lg:px-10">
        <div className="text-center mb-12">
          <span className="inline-block bg-green-50 text-[#4CAF50] text-[0.875rem] font-medium px-4 py-1.5 rounded-full mb-4 border border-green-200">
            劑型選擇
          </span>
          <h2 className="text-[#1a2e1a] font-bold mb-4">
            多種劑型，滿足市場需求
          </h2>
          <p className="text-gray-500 text-[1.0625rem] leading-[1.75] max-w-2xl mx-auto">
            康永生技擁有完整的劑型生產線，依據產品定位與目標族群選擇最合適的劑型
          </p>
        </div>

        {/* Tab switcher */}
        <div className="flex flex-wrap justify-center gap-2 mb-10">
          {categories.map((cat) => (
            <button
              key={cat}
              onClick={() => setActive(cat)}
              className={`whitespace-nowrap px-5 py-2 rounded-full text-[0.9375rem] font-medium transition-all duration-200 cursor-pointer ${
                active === cat
                  ? 'bg-[#4CAF50] text-white'
                  : 'bg-white text-gray-500 border border-gray-200 hover:border-green-300 hover:text-[#4CAF50]'
              }`}
            >
              {cat}
            </button>
          ))}
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {filtered.map((item) => (
            <Link
              key={item.name}
              to={`/services/dosage-forms#${item.anchor}`}
              className="bg-white rounded-2xl overflow-hidden border border-gray-100 hover:border-green-200 hover:-translate-y-1 transition-all duration-300 block cursor-pointer"
            >
              <div className="w-full h-[220px] overflow-hidden">
                <img src={item.img} alt={item.name} className="w-full h-full object-cover object-top" />
              </div>
              <div className="p-6">
                <span className="inline-block bg-green-50 text-[#4CAF50] text-[0.75rem] font-medium px-3 py-1 rounded-full mb-3 border border-green-100">
                  {item.category}
                </span>
                <h3 className="text-[#1a2e1a] font-bold text-[1.0625rem] mb-2">{item.name}</h3>
                <p className="text-gray-500 text-[0.875rem] leading-[1.75] mb-4">{item.desc}</p>
                <div className="flex flex-wrap gap-2">
                  {item.tags.map((tag) => (
                    <span key={tag} className="bg-[#f7faf7] border border-gray-200 text-gray-500 text-[0.75rem] px-3 py-1 rounded-full">
                      {tag}
                    </span>
                  ))}
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}